import { render } from "./PlanJournal.vue?vue&type=template&id=4b82d228&ts=true"
import script from "./PlanJournal.vue?vue&type=script&lang=ts"
export * from "./PlanJournal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__